// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__WudRp","tools":"Skills_tools__FPoHJ","grid":"Skills_grid__LDqoP"};